<widget-wp-table [resource]="resource"
                 (resourceChanged)="onResourceChanged($event)"></widget-wp-table>
